import Keycloak from 'keycloak-js'

let instance: Keycloak | null = null

const getKeycloakInstance = () => {
  if (!instance) {
    instance = new Keycloak({
      realm: 'spf-mb-dev',
      'auth-server-url': `${process.env.KEYCLOAK_SERVER}/auth/`,
      url: `${process.env.KEYCLOAK_SERVER}/auth/`,
      clientId: 'spf-manger-bouger-fam',
      'public-client': true,
      'confidential-port': 0,
    } as any)
  }
  return instance
}

const isSafariBrowser = () => {
  return (
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') === -1 &&
    navigator.userAgent.indexOf('FxiOS') === -1
  )
}

const isComingFromSSO = () => {
  const url = new URL(window.location.href)
  return url.hash.includes('session_state') && url.hash.includes('code')
}

export const getKeycloakToken = async (
  previousToken: string,
  previousTokenIsAnonymous: boolean
) => {
  if (typeof window !== 'undefined') {
    const prefix =
      typeof process.env.ASSET_PREFIX !== 'undefined'
        ? process.env.ASSET_PREFIX
        : ''

    const keycloak = getKeycloakInstance()
    const isSafari = isSafariBrowser()
    const isFromSSO = isComingFromSSO()

    if (
      isSafari &&
      (!previousToken || previousTokenIsAnonymous) &&
      !isFromSSO
    ) {
      return false
    }

    try {
      const authenticated = await keycloak.init({
        // Because of "Prevent cross-site tracking" option, silent check sso is not working on safari (see: https://www.keycloak.org/docs/22.0.5/securing_apps/index.html#_modern_browsers)
        ...(isSafari &&
          ((previousToken && !previousTokenIsAnonymous) || isFromSSO) && {
            onLoad: 'login-required',
            checkLoginIframe: false,
          }),
        ...(!isSafari && {
          onLoad: 'check-sso',
          silentCheckSsoRedirectUri:
            window.location.origin + prefix + '/silent-check-sso',
        }),
      })

      if (authenticated) {
        return keycloak.token
      } else {
        return false
      }
    } catch (error) {
      console.error('keycloak failed to initialize : ', error)
    }
  }
}

export const refreshKeycloakToken = async () => {
  const keycloak = getKeycloakInstance()
  await keycloak.updateToken(60 * 15)
  return keycloak.token
}
